module.exports = __webpack_public_path__ + "static/img/recruimentBanner.e8b07af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/recruimentBanner.png
// module id = XRH0
// module chunks = 1